// components/Firebase/TokenContext.js
import React, { createContext, useContext, useState } from "react";

const TokenContext = createContext();

export const TokenProvider = ({ children }) => {
  const [firebaseToken, setFirebaseToken] = useState(null);
  return (
    <TokenContext.Provider value={{ firebaseToken, setFirebaseToken }}>
      {children}
    </TokenContext.Provider>
  );
};

export const useToken = () => useContext(TokenContext);
